import { Grid } from 'antd';
import ReactPlayer from 'react-player';
import useMounted from 'src/hooks/useMounted';

const VideoStemcell = () => {
	const { md, xl } = Grid.useBreakpoint();
	const mounted = useMounted();

	return (
		<div className="bg-white">
			<div className="container pt-1 pb-4 md:pt-2 md:pb-12">
				<div className="text-center">
					<h2 className="mt-4 mb-6 py-4 text-center font-bold text-[42px] max-xl:mt-1 max-xl:text-2xl max-xs:mt-0 max-xs:text-xl max-xs:font-semibold max-xs:leading-7">
						Tonton Video Edukasi <br /> Tentang Stem Cell di Indonesia berikut ini!
					</h2>
				</div>
				{mounted ? (
					<div className="flex justify-center">
						<ReactPlayer
							controls
							url={process.env.NEXT_PUBLIC_STEM_CELL_VIDEO}
							width={xl ? 960 : md ? 720 : 320}
							height={xl ? 540 : md ? 405 : 180}
						/>
					</div>
				) : null}
			</div>
		</div>
	);
};

export default VideoStemcell;
